// @flow
import type { MaybeAToMaybeAB } from 'app/common/react/components/closeup/utils/types';

// Pin Data Transformations
type AToMaybeAB<A, B> = (value: A) => ?(A & B);

function createMaybeTransform<A, B>(transform: AToMaybeAB<A, B>): MaybeAToMaybeAB<A, B> {
  return function(value) {
    if (value !== null && value !== undefined) {
      return transform(value);
    } else {
      return null;
    }
  };
}

export default createMaybeTransform;
